import React from "react";
import "../css/Cassette_AC_Repair.css";
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; 
import Herolast  from "../screen/herolast";
export default function Cassette_AC_Repair() {
  return (
    <>
     <Topbar/>
      <Header />
      {/* Hero (your original card) */}
      <section className="ac-hero">
        <div className="ac-hero-bg" />

        <div className="ac-hero-card">
          <p className="ac-hero-kicker">Expert Cassette AC Repair and Service</p>

          <h1 className="ac-hero-title">
           Keeping Your Cool All Year
           <br/>
           Round!
          </h1>

          <p className="ac-hero-subtitle">
         Cassette AC repair and service at your doorstep in 30 minutes. Schedule your service now!
          </p>

          <a className="ac-hero-cta" href="tel:7237898275">
            7237898275
          </a>
        </div>
      </section>

        {/* === New content section: two-column layout like screenshots === */}
      <section className="ac-article-section">
        <div className="container ac-article-grid">
          <div className="ac-article-text">
            <h2 className="ac-article-heading">Your Trusted Partner for Cassette AC Repair and Service</h2>

            <p> At<a className="ac-link" href="#">Jay Ambe AC Service</a>,we understand that maintaining a comfortable indoor environment is essential, especially during the sweltering summer months. Our specialized <strong> cassette air conditioning repair and service </strong>  ensure your system operates efficiently, providing you with optimal cooling when you need it most.
            </p>

            <p>
            Cassette AC units are an excellent choice for spaces with limited wall space or high ceilings. Their sleek design allows them to blend seamlessly into any interior while delivering powerful airflow. However, like all HVAC systems, they require regular maintenance and prompt repairs to function at their best. That’s where our expert team comes in.           
             </p>

         
            <p>
      With years of experience in the industry, Jay Ambe AC Service offers comprehensive services tailored to your specific needs. Our trained technicians are equipped with the knowledge and tools necessary to diagnose issues quickly and accurately. Whether it’s a refrigerant leak, electrical problem, or simply routine maintenance such as cleaning filters and coils, we handle it all with precision.
            </p>

            <p>
         We pride ourselves on our commitment to customer satisfaction. When you choose us for your cassette AC repair or service needs, you can expect transparent communication throughout the process. We provide detailed assessments of your unit’s condition along with honest recommendations for repairs or replacements if needed.         
            </p>


          <p>Furthermore, we understand that time is of the essence when it comes to air conditioning issues—especially during peak seasons. That’s why we offer flexible scheduling options and strive for quick turnaround times without compromising quality.</p>
          <p>Choose Jay AMbe AC Service today for reliable cassette air conditioning solutions that keep your space cool and comfortable!</p>
          </div>

          <div className="ac-article-image-wrap">
            <img
              className="ac-article-image"
              src={require("../assets/cassette-ac-service.jpg")}
              alt="AC service"
            />
          </div>
        </div>
      </section>
<Herolast  />
      <Footer  />
     
    </>
  );
}
